/**
 * ANQ.ContentServiceManagement.API 
 * Content Service Mgt API
 *
 * OpenAPI spec version: v1
 * Contact: support@coure-tech.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { Content } from '../model/content';
import { ContentDtos } from '../model/contentDtos';
import { ContentProviderContentCountDto } from '../model/contentProviderContentCountDto';
import { CreateContent } from '../model/createContent';
import { ProblemDetails } from '../model/problemDetails';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class ContentService {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiContentCreateContentPost(body?: CreateContent, observe?: 'body', reportProgress?: boolean): Observable<string>;
    public apiContentCreateContentPost(body?: CreateContent, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<string>>;
    public apiContentCreateContentPost(body?: CreateContent, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<string>>;
    public apiContentCreateContentPost(body?: CreateContent, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<string>('post',`${this.basePath}/api/Content/CreateContent`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param contentProviderId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiContentGetAllByContentProviderIdGet(contentProviderId?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<ContentDtos>>;
    public apiContentGetAllByContentProviderIdGet(contentProviderId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ContentDtos>>>;
    public apiContentGetAllByContentProviderIdGet(contentProviderId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ContentDtos>>>;
    public apiContentGetAllByContentProviderIdGet(contentProviderId?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (contentProviderId !== undefined && contentProviderId !== null) {
            queryParameters = queryParameters.set('contentProviderId', <any>contentProviderId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ContentDtos>>('get',`${this.basePath}/api/Content/GetAllByContentProviderId`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param contentProviderName 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiContentGetAllContentByContentProviderNameGet(contentProviderName?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<Content>>;
    public apiContentGetAllContentByContentProviderNameGet(contentProviderName?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<Content>>>;
    public apiContentGetAllContentByContentProviderNameGet(contentProviderName?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<Content>>>;
    public apiContentGetAllContentByContentProviderNameGet(contentProviderName?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (contentProviderName !== undefined && contentProviderName !== null) {
            queryParameters = queryParameters.set('contentProviderName', <any>contentProviderName);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<Content>>('get',`${this.basePath}/api/Content/GetAllContentByContentProviderName`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiContentGetAllGet(observe?: 'body', reportProgress?: boolean): Observable<ContentDtos>;
    public apiContentGetAllGet(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ContentDtos>>;
    public apiContentGetAllGet(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ContentDtos>>;
    public apiContentGetAllGet(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ContentDtos>('get',`${this.basePath}/api/Content/GetAll`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param contentName 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiContentGetContentByContentNameGet(contentName?: string, observe?: 'body', reportProgress?: boolean): Observable<Content>;
    public apiContentGetContentByContentNameGet(contentName?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Content>>;
    public apiContentGetContentByContentNameGet(contentName?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Content>>;
    public apiContentGetContentByContentNameGet(contentName?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (contentName !== undefined && contentName !== null) {
            queryParameters = queryParameters.set('contentName', <any>contentName);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Content>('get',`${this.basePath}/api/Content/GetContentByContentName`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiContentGetContentByIdGet(id?: string, observe?: 'body', reportProgress?: boolean): Observable<Content>;
    public apiContentGetContentByIdGet(id?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Content>>;
    public apiContentGetContentByIdGet(id?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Content>>;
    public apiContentGetContentByIdGet(id?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (id !== undefined && id !== null) {
            queryParameters = queryParameters.set('id', <any>id);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Content>('get',`${this.basePath}/api/Content/GetContentById`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param contentProviderName 
     * @param skip 
     * @param take 
     * @param search 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiContentGetContentProviderContentByCpNameAndSearchGet(contentProviderName?: string, skip?: number, take?: number, search?: string, observe?: 'body', reportProgress?: boolean): Observable<ContentProviderContentCountDto>;
    public apiContentGetContentProviderContentByCpNameAndSearchGet(contentProviderName?: string, skip?: number, take?: number, search?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ContentProviderContentCountDto>>;
    public apiContentGetContentProviderContentByCpNameAndSearchGet(contentProviderName?: string, skip?: number, take?: number, search?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ContentProviderContentCountDto>>;
    public apiContentGetContentProviderContentByCpNameAndSearchGet(contentProviderName?: string, skip?: number, take?: number, search?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {





        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (contentProviderName !== undefined && contentProviderName !== null) {
            queryParameters = queryParameters.set('contentProviderName', <any>contentProviderName);
        }
        if (skip !== undefined && skip !== null) {
            queryParameters = queryParameters.set('skip', <any>skip);
        }
        if (take !== undefined && take !== null) {
            queryParameters = queryParameters.set('take', <any>take);
        }
        if (search !== undefined && search !== null) {
            queryParameters = queryParameters.set('search', <any>search);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ContentProviderContentCountDto>('get',`${this.basePath}/api/Content/GetContentProviderContentByCpNameAndSearch`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
